import { instanceOf, string } from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { Button, Segment } from 'semantic-ui-react'
import Icons from '../../assets/icons'

import './SecondaryMenu.scss'

function SecondaryMenu({ items, activeItem }) {
  const navigate = useNavigate()
  const setIcon = (type, active) => {
    const className = active ? '' : 'secondary_inactive_icon'
    switch (type) {
      case 'barChart':
        return <Icons.BarChartIcon className={className} />
      case 'calendar':
        return <Icons.CalendarIcon className={className} />
      case 'video':
        return <Icons.VideoIcon className={className} />
      case 'lineChart':
        return <Icons.LineChartIcon className={className} />
      case 'notePanel':
        return <Icons.NotePanelIcon className={className} />
      case 'sun':
        return <Icons.SunIcon className={className} />
      case 'circle':
        return <Icons.CircleIcon className={className} />
      case 'note':
        return <Icons.NoteIcon className={className} />
      default:
        return null
    }
  }
  return (
    <Segment className='secondary_segment'>
      {items.map((item, i) => (
        <Button
          key={i}
          className={activeItem === item.link ? 'active_secondary_menu_button' : 'secondary_menu_button'}
          onClick={() => navigate(item.link)}
        >
          {setIcon(item.icon, activeItem === item.link)}
          <div className='secondary_icon_text'>{item.name}</div>
        </Button>
      ))}
    </Segment>
  )
}

SecondaryMenu.propTypes = {
  items: instanceOf(Array),
  activeItem: string,
}

export default SecondaryMenu
